import { render, staticRenderFns } from "./MaterialCreativeRead.vue?vue&type=template&id=dacb59ee&scoped=true&"
import script from "./MaterialCreativeRead.vue?vue&type=script&lang=js&"
export * from "./MaterialCreativeRead.vue?vue&type=script&lang=js&"
import style0 from "./MaterialCreativeRead.vue?vue&type=style&index=0&lang=css&"
import style1 from "./MaterialCreativeRead.vue?vue&type=style&index=1&id=dacb59ee&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dacb59ee",
  null
  
)

export default component.exports